import { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import PageHeading from '../../../../Components/PageHeading';

import useCommonStyles from '../../../../commonStyles';
import { Alert, Grid, Paper } from '@mui/material';
import { ConfigContext } from '../../../../Contexts/ConfigContext';

const HbWithoutGamConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="HB Without GAM"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'HB Without GAM']}
				description="Serve direct HB creatives from Prebid server in case unfilled from Adx (inflates the HB bids and sends as floor for Adx)"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Alert sx={{ width: '100%', margin: '2rem auto', paddingLeft: '5rem' }} severity="warning">
				This feature should only be enabled after approval from the product team.
			</Alert>
			<Grid container spacing={1} style={{ marginLeft: '5rem', width: '90%' }}>
				<Grid item xs={2} style={{ marginTop: '4.5rem' }}>
					<CheckBoxInput
						keyData={`${keyData}.enabled`}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
			<Grid container spacing={2} style={{ marginTop: '1rem', marginLeft: '4rem', width: '90%' }}>
				<Grid item xs={3}>
					<InputConfig
						label="GAM UPR Multiplier"
						keyData={`${keyData}.gamUprMultiplier`}
						editable={!!rawConfig[`${keyData}.enabled`]}
						inputType="number"
						placeholder="Default (0.75)"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Floor Inflation Multiplier"
						keyData={`${keyData}.floorInflationMultiplier`}
						editable={!!rawConfig[`${keyData}.enabled`]}
						inputType="number"
						placeholder="Default (1.1)"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default HbWithoutGamConfig;
